import { useTranslation } from "react-i18next";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter,
  DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Lock, Sparkles } from "lucide-react";
import { productLabel } from "@/lib/branding";

const FEATURE_LABEL = {
  invoicing: "Ventes & Facturation",
  expenses: "Achats & Dépenses",
  treasury: "Trésorerie",
  accounting: "Comptabilité",
  hr: "RH & Paie",
  legal: "Juridique",
  crm: "CRM",
  ai_copilot: productLabel("IA"),
  multi_tenant: "Multi-tenant Cabinet",
  rebilling: "Refacturation IA-first",
  legal_ocr_extended: "OCR IA étendu (8 types + prefill AGO/AGE)",
  legal_wizard_age: "Wizard AGE typé (7 types métier)",
  legal_batch_convocations: "Convocations groupées par associé",
  legal_ai_digest: "Digest hebdo CFO + résumé IA",
  legal_multi_country: "Multi-pays FR / BE / LU",
  legal_whitelabel: "Templates whitelabel + logo sur PDF",
  api_public: "API publique v1 + webhooks HMAC",
};

const FEATURE_PLAN_HINT = {
  rebilling: "Pro, Croissance ou Grande entreprise",
  legal_ocr_extended: "Croissance, Grande entreprise ou Cabinet",
  legal_wizard_age: "Croissance ou Grande entreprise",
  legal_batch_convocations: "Croissance ou Grande entreprise",
  legal_ai_digest: "Croissance ou Grande entreprise",
  legal_multi_country: "Grande entreprise ou Cabinet",
  legal_whitelabel: "Croissance, Grande entreprise ou Cabinet",
  api_public: "Grande entreprise ou Cabinet",
};

export default function UpsellDialog({ open, onOpenChange, feature, included, onGoToPlan }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="upsell-dialog" className="max-w-md">
        <DialogHeader>
          <div className="h-10 w-10 rounded-lg bg-blue-50 flex items-center justify-center mb-2">
            {included ? (
              <Sparkles className="h-5 w-5 text-blue-600" />
            ) : (
              <Lock className="h-5 w-5 text-blue-600" />
            )}
          </div>
          <DialogTitle className="text-xl">
            {FEATURE_LABEL[feature] || feature}
          </DialogTitle>
          <DialogDescription>
            {included ? t("dashboard.moduleLocked") : (
              <>
                Cette fonctionnalité premium est incluse dans les plans{" "}
                <strong>{FEATURE_PLAN_HINT[feature] || "supérieurs"}</strong>.{" "}
                Passez à un plan supérieur pour l'activer immédiatement.
              </>
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="upsell-close-btn">
            {t("common.cancel")}
          </Button>
          {!included && (
            <Button onClick={onGoToPlan} data-testid="upsell-cta-btn" className="bg-blue-600 hover:bg-blue-700">
              {t("dashboard.upgradeCta")}
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
